import { formatDate } from "../../core/utils";
import constants from "../../core/constants";
import moment from "moment";

export const holidayItem = {
  title: "Corporate Holiday",
  state: "corporateholiday",
  name: "corporateholiday",
};

export const subscriptionFields = [
  { title: "User", name: "user" },
  { title: "City", name: "city" },
  { title: "Pickup", name: "pick_up" },
  { title: "Drop Off", name: "drop_off" },
];

export const reservationFields = [
  { title: "Route", name: "route" },
  { title: "Schedule", name: "schedule" },
  { title: "Ride Price", name: "ride_price" },
  { title: "Supply Cost", name: "supply_cost" },
];

export const invoiceFields = [
  { title: "Start Date", name: "start_date" },
  { title: "End Date", name: "end_date" },
  { title: "Status", name: "status" },
  { title: "Total Amount", name: "total_amount" },
  { title: "Paid", name: "paid" },
];

export const userFields = [
  { title: "Name", name: "name" },
  { title: "Email", name: "email" },
  { title: "Phone", name: "phone" },
  { title: "Created At", name: "createdAt" },
  {
    title: "Whitelisted",
    name: "whitelistingStatus",
    infoTooltip: "Employees added through the TaaS dashboard",
  },
];

export const holidayFields = [
  { title: "Name", name: "name" },
  { title: "Date", name: "date" },
  { title: "Schedules on Holiday", name: "holidaySchedules" },
  { title: "Total Corporate Schedules", name: "totalSchedules" },
];

export const holidayAddOptions = {
  title: "Add New Corporate Holiday",
  icon: "add",
  fields: [
    { name: "name", title: "Name", type: "text", isText: true },
    {
      name: "date",
      title: "Select date",
      icon: "date_range",
      date: true,
      formatter: formatDate,
      minDate: moment().add("days", 1),
    },
  ],
};

export const officeLocationItem = {
  title: "corporate office location",
  state: "corporate_office_location",
  name: "corporate_office_location",
};

export const officeLocationsAddOptions = {
  title: "Add New Office Location",
  icon: "add",
  fields: [
    {
      name: "name",
      title: "Location Name",
      type: "text",
      isText: true,
      isRequired: true,
    },
    {
      name: "location",
      title: "Location",
      isLocation: true,
      isRequired: true,
    },
  ],
};

export const shiftItem = {
  title: "corporate shift",
  state: "corporate_shift",
  name: "corporate_shift",
};
export const uploadsFields = [
  {
    title: "Uploaded File ",
    name: "uploaded_file_name",
    url: "uploaded_file_url",
  },
  { title: "Time", name: "uploaded_file_time" },
  { title: "Uploaded User", name: "user" },
  {
    title: "Result File",
    name: "result_file_name",
    url: "result_file_url",
  },
  { title: "Time", name: "result_file_time" },
];

export const durations = [{ title: "Months", name: "month" }];

export const planType = [
  { name: "percentage", display: "Percentage (%)" },
  { name: "fixed", display: "Fixed" },
];

export const prices = {
  busType: [
    {
      name: "ride_price",
      title: "Ride Price",
      required: true,
      renderFor: "busType",
      forStep: "type",
      component: "numberField",
    },
  ],
  busTypeRoute: [
    {
      name: "ride_price",
      title: "Ride Price",
      required: true,
      renderFor: "busTypeRoute",
      forStep: "type",
      component: "numberField",
    },
  ],
  lumpsum: [
    {
      name: "invoice_period",
      title: "Invoice Period",
      renderFor: "lumpsum",
      forStep: "type",
      component: "multiSelectField",
      options: [{ title: "Month", value: "monthly" }],
      required: true,
    },
    {
      name: "price",
      title: "Fixed Amount",
      renderFor: "lumpsum",
      forStep: "type",
      component: "numberField",
      required: true,
    },
    {
      name: "buses_count",
      title: "No. of Buses",
      renderFor: "lumpsum",
      forStep: "type",
      component: "numberField",
      required: true,
    },
    {
      name: "rides_per_bus",
      title: "No. of Rides/Day",
      renderFor: "lumpsum",
      forStep: "type",
      component: "numberField",
      required: true,
    },
    {
      name: "maximum_rides",
      title: "Max Rides/Day",
      renderFor: "lumpsum",
      forStep: "type",
      component: "numberField",
      required: false,
    },
    {
      name: "maximum_distance",
      title: "Max KMs/Day",
      renderFor: "lumpsum",
      forStep: "type",
      component: "numberField",
      required: false,
    },
    {
      name: "extra_ride_pricing_type",
      title: "Extra Ride Charge Type",
      renderFor: "lumpsum",
      forStep: "type",
      component: "multiSelectField",
      options: [
        { title: "Fixed", value: "fixed" },
        { title: "Multiplier", value: "multiplier" },
      ],
      required: false,
    },
    {
      name: "extra_ride_pricing_value",
      title: "Extra Ride Charge/Day",
      renderFor: "lumpsum",
      forStep: "type",
      component: "numberField",
      required: false,
    },
    {
      name: "extra_distance_price",
      title: "Extra Km Charge",
      renderFor: "lumpsum",
      forStep: "type",
      component: "numberField",
      required: false,
    },
    {
      name: "weekdays",
      title: "Working Days",
      renderFor: "lumpsum",
      forStep: "type",
      component: "weekdaysField",
      required: true,
    },
  ],
};

export const supplyPrices = {
  busType: [
    {
      name: "captain_price",
      title: "Supply Cost",
      renderFor: "busType",
      forStep: "type",
      component: "numberField",
      required: false,
    },
  ],
  busTypeRoute: [
    {
      name: "captain_price",
      title: "Supply Cost",
      renderFor: "busTypeRoute",
      forStep: "type",
      component: "numberField",
      required: false,
    },
  ],
  lumpsum: [
    {
      name: "captain_price",
      title: "Supply Cost",
      renderFor: "lumpsum",
      forStep: "type",
      component: "numberField",
      required: false,
    },
  ],
};

export const accountManagers = [{ name: "name", title: "Name" }];
// Contracts fields for stepper component
export const contractSteps = [
  {
    name: "type",
    title: "Type",
    component: "select",
    options: [
      {
        name: "buses_only",
        value: "busType",
        title: "Bus Only Contract",
        icon: "directions_bus",
        disabled: false,
      },
      {
        name: "buses_routes",
        value: "busTypeRoute",
        title: "Bus/Route Contract",
        icon: "directions",
        disabled: false,
      },
      {
        name: "lumpsum",
        value: "lumpsum",
        title: "Lumpsum Contract",
        icon: "request_quote",
        disabled: false,
      },
    ],
    show: true,
  },
  {
    name: "selected_buses",
    modelName: "selectedBuses",
    title: "Buses",
    component: "multi_select",
    resource: "Bustype",
    resourceMethod: "getAll",
    resourceOption: "City",
    resourceParam: "_id",
    conditional: {
      name: "selected_routes",
      bindSelection: "tempRoute",
      target: "busTypeRoute",
      targetPath: "type",
      component: "search_and_chip",
      resource: "Route",
      title: "Select Route",
      event: "routesEvent",
    },
    show: false,
  },
  {
    name: "pricing",
    title: "Ride Pricing",
    component: "multi_dim_inputs",
    countName: "seats",
    countValue: "max_seats",
    options: prices,
    checkOn: "type",
    // Connections as array
    connectedSecond: "selected_routes",
    connectedDefault: "selected_buses",
    connectedDefaultKey: "bus_type",
    connectedThrough: "length",
    show: false,
  },
  {
    name: "pricing",
    title: "Supply Price",
    component: "multi_dim_inputs",
    countName: "seats",
    countValue: "max_seats",
    options: supplyPrices,
    checkOn: "type",
    connectedSecond: "selected_routes",
    connectedDefault: "selected_buses",
    connectedDefaultKey: "bus_type",
    connectedThrough: "length",
    show: false,
  },
  {
    name: "penalty_plan",
    title: "SWVL Penalty Plans",
    component: "list_objects",
    options: {
      amountTypes: planType,
    },
    required: false,
    show: false,
  },
  {
    name: "deduction_plan",
    title: "Supply Deduction Plans",
    component: "list_objects",
    options: {
      amountTypes: planType,
    },
    required: false,
    show: false,
  },
  {
    name: "start_date",
    title: "Start Date",
    component: "date_picker",
  },
  {
    name: "expiry_date",
    title: "Expiry Date",
    component: "date_picker",
  },
  {
    name: "attachment",
    title: "Contract Attachment",
    component: "document",
    option: {
      maxSize: "2",
      sizeUnit: "MB",
      fileType: [".pdf"],
    },
    show: false,
    required: true,
  },
];

export const addOptions = {
  title: "Add New Corporate Reservation",
  icon: "add",
  fields: [
    {
      resource: "Route",
      name: "route",
      title: "Route",
      isResource: true,
      isRequired: true,
    },
    {
      name: "ride_price",
      title: "Ride Price",
      type: "number",
      isText: true,
      isRequired: true,
      formatter: (item) => item * constants.currencyBy,
    },
    {
      name: "supply_cost",
      title: "Supply Cost",
      type: "number",
      isText: true,
      isRequired: true,
      formatter: (item) => item * constants.currencyBy,
    },
    {
      resource: "Schedule",
      name: "schedule",
      title: "Schedule",
      isListResource: true,
      isRequired: true,
      requires: "route",
      resourceParams: { limit: 0 },
      listTransformer: "RouteTransforms",
      listTransformerMethod: "justifySchedule",
    },
  ],
};



// WEBPACK FOOTER //
// ./src/pages/corporate/fields.js